import React, { useEffect, useState } from "react";
import { useAuth } from "../../auth/AuthContext"; // Verify this path matches About.js
import PrimaryButton from "../../PrimaryButton";
import Footer from "../home/Footer";
import { Link } from "react-router-dom";
import { ButtonBase, Box } from "@mui/material";

const Service = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const authValue = useAuth(); // Full value for logging
  const { getData } = authValue; // Destructure

  // DEBUG LOGS: Add these temporarily
  //console.log('Service - useAuth full value:', authValue);
  //console.log('Service - getData type:', typeof getData);
  //console.log('Service - getData:', getData);

  useEffect(() => {
    async function fetchData() {
      if (typeof getData !== "function") {
        const msg =
          "getData is not available. Check: 1) AuthProvider wrapping, 2) Import path, 3) Context value.";
        console.error(msg);
        setError(msg);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);
        const response = await getData("proccess.php", "department");
        if (response.success) {
          setServices(response.data);
        } else {
          setError(response.message || "Failed to fetch services");
        }
      } catch (err) {
        console.error("Fetch error in Service:", err);
        setError(err.message || "Network error");
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [getData]);

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "2rem" }}>
        Loading services...
      </div>
    );
  }

  return (
    <>
      <div
        style={{
          width: "100%",
          minHeight: "70vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center", // Changed to flex-start for better layout
          gap: "1rem",
          paddingTop: "100px",
          backgroundColor: "#e7f1f5",
        }}
      >
        {/* <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "2rem",
            backgroundColor: "#ffffffff",
            paddingTop: '4rem'
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: "1200px",
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              justifyContent: "center",
              gap: "2rem",
              height: "40vh",
              padding: "1rem",
            }}
          >
            <h1
              className="primary-header"
              style={{ textAlign: "start", color: "#000000ff" }}
            >
              We Are More Than Just A STEAM Centre
            </h1>
            <p
              style={{
                color: "#000000ff",
                fontSize: "1.3rem",
                textAlign: "start",
              }}
            >
              Mindsinaction is uniquely positioned to offer specialized
              technical services and consultation, providing expertise across{" "}
              <b>
                {" "}
                ICT (Information and Communications Technology), STEAM (Science,
                Technology, Engineering, Arts, and Mathematics) Innovation
                Consulting, and Engineering Fabrication.{" "}
              </b>
            </p>
          </div>
        </div> */}

        <div
          style={{
            width: "100%",
            maxWidth: "1200px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "1rem",
            padding: "2rem",
          }}
        >
          {error && (
            <p style={{ color: "red", textAlign: "center" }}>Error: {error}</p>
          )}
          {services.length > 0 ? (
            <ul
              style={{
                listStyle: "none",
                padding: 0,
                width: "100%",
                display: "flex",
                flexWrap: "wrap",
                gap: "1rem",
              }}
            >
              {services.map((service, index) => (
                <>
                  {service.department_name === "STEAM" && (
                    <li
                      key={service.id || index}
                      style={{
                        backgroundColor: "#ffffffff",
                        padding: "1rem",
                        margin: "0.5rem 0",
                        borderRadius: "8px",
                        flex: 1,
                        minWidth: "300px",
                        maxWidth: "400px",
                        boxSizing: "border-box",
                        position: "relative",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          height: "200px",
                          overflow: "hidden",
                        }}
                      >
                        <img
                          src={`https://mindsinaction.com.na/assets/media/pictures/${service.image}`}
                          alt="services"
                          style={{
                            width: "100%",
                          }}
                        />
                      </div>
                      {/* Adapt to your data; assuming similar structure to modules in About.js */}
                      <h3
                        style={{
                          position: "absolute",
                          top: "15px",
                          left: "0",
                          background:
                            "linear-gradient(to right , #3b76b2, #32a059, transparent)",
                          width: "90%",
                          padding: "1rem",
                          color: "#fff",
                          fontWeight: "700",
                          lineHeight: "1.8rem",
                        }}
                      >
                        {service.department_name || `Service ${index + 1}`}
                        <br />
                        <span
                          style={{
                            fontWeight: "300",
                            fontSize: "1rem",
                          }}
                        >
                          Namibia
                        </span>
                      </h3>

                      <p
                        style={{
                          width: "100%",
                          minHeight: '100px',
                          maxHeight: '350px',
                          overflow: "auto",
                          padding: "1rem 0",
                        }}
                      >
                        {service.short_description || "No description available"}
                      </p>
                      <Link to={`/services/${service.department_name}/?code=${service.id}`}>
                        <ButtonBase
                          sx={{
                            backgroundColor: "#3b76b2",
                            padding: ".5rem 1rem",
                            border: "none",
                            borderRadius: "1rem",
                            color: '#fff'
                          }}
                        >
                          Read More
                        </ButtonBase>
                      </Link>
                    </li>
                  )}
                </>
              ))}
              {services.map((service, index) => (
                <>
                  {service.department_name === "ICT" && (
                    <li
                      key={service.id || index}
                      style={{
                        backgroundColor: "#ffffffff",
                        padding: "1rem",
                        margin: "0.5rem 0",
                        borderRadius: "8px",
                        flex: 1,
                        minWidth: "300px",
                        maxWidth: "400px",
                        boxSizing: "border-box",
                        position: "relative",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          height: "200px",
                          overflow: "hidden",
                        }}
                      >
                        <img
                          src={`https://mindsinaction.com.na/assets/media/pictures/${service.image}`}
                          alt="services"
                          style={{
                            width: "100%",
                          }}
                        />
                      </div>
                      {/* Adapt to your data; assuming similar structure to modules in About.js */}
                      <h3
                        style={{
                          position: "absolute",
                          top: "15px",
                          left: "0",
                          background:
                            "linear-gradient(to right , #3b76b2, #32a059, transparent)",
                          width: "90%",
                          padding: "1rem",
                          color: "#fff",
                          fontWeight: "700",
                          lineHeight: "1.8rem",
                        }}
                      >
                        {service.department_name || `Service ${index + 1}`}
                        <br />
                        <span
                          style={{
                            fontWeight: "300",
                            fontSize: "1rem",
                          }}
                        >
                          Namibia
                        </span>
                      </h3>

                      <p
                        style={{
                          width: "100%",
                          minHeight: '100px',
                          maxHeight: '350px',
                          overflow: "auto",
                          padding: "1rem 0",
                        }}
                      >
                        {service.short_description || "No description available"}
                      </p>
                      <Link to={`/services/${service.department_name}/?code=${service.id}`}>
                        <ButtonBase
                          sx={{
                            backgroundColor: "#3b76b2",
                            padding: ".5rem 1rem",
                            border: "none",
                            borderRadius: "1rem",
                            color: '#fff'
                          }}
                        >
                          Read More
                        </ButtonBase>
                      </Link>
                    </li>
                  )}
                </>
              ))}
              {services.map((service, index) => (
                <>
                  {service.department_name === "Engineering" && (
                    <li
                      key={service.id || index}
                      style={{
                        backgroundColor: "#ffffffff",
                        padding: "1rem",
                        margin: "0.5rem 0",
                        borderRadius: "8px",
                        flex: 1,
                        minWidth: "300px",
                        maxWidth: "400px",
                        boxSizing: "border-box",
                        position: "relative",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          height: "200px",
                          overflow: "hidden",
                        }}
                      >
                        <img
                          src={`https://mindsinaction.com.na/assets/media/pictures/${service.image}`}
                          alt="services"
                          style={{
                            width: "100%",
                          }}
                        />
                      </div>
                      {/* Adapt to your data; assuming similar structure to modules in About.js */}
                      <h3
                        style={{
                          position: "absolute",
                          top: "15px",
                          left: "0",
                          background:
                            "linear-gradient(to right , #3b76b2, #32a059, transparent)",
                          width: "90%",
                          padding: "1rem",
                          color: "#fff",
                          fontWeight: "700",
                          lineHeight: "1.8rem",
                        }}
                      >
                        {service.department_name || `Service ${index + 1}`}
                        <br />
                        <span
                          style={{
                            fontWeight: "300",
                            fontSize: "1rem",
                          }}
                        >
                          Namibia
                        </span>
                      </h3>

                      <p
                        style={{
                          width: "100%",
                          minHeight: '100px',
                          maxHeight: '350px',
                          overflow: "auto",
                          padding: "1rem 0",
                        }}
                      >
                        {service.short_description || "No description available"}
                      </p>
                      <Link to={`/services/${service.department_name}/?code=${service.id}`}>
                        <ButtonBase
                          sx={{
                            backgroundColor: "#3b76b2",
                            padding: ".5rem 1rem",
                            border: "none",
                            borderRadius: "1rem",
                            color: '#fff'
                          }}
                        >
                          Read More
                        </ButtonBase>
                      </Link>
                    </li>
                  )}
                </>
              ))}
            </ul>
          ) : (
            !loading &&
            !error && (
              <p style={{ textAlign: "center" }}>No services available.</p>
            )
          )}
        </div>
      </div>
      {/* footer */}
      <Footer />
    </>
  );
};

export default Service;
